(function (global) {
  "use strict";

  var VirtualTryOnSdk = function () {
    this.isYMKModuleLoaded = false;
  };

  VirtualTryOnSdk.prototype.loadYMKModule = function (
    container,
    successCallback,
  ) {
    const YMK_SDK_URL = theme.vtoSettings?.path;
    const YMK_SDK_API_KEY = theme.vtoSettings?.apiKey;
    if (!YMK_SDK_URL || !YMK_SDK_API_KEY) {
      return false;
    }
    this.moduleContainer = container.querySelector(".YMK-module-container");

    if (!this.moduleContainer) {
      return false;
    }

    if (window.YMK && document.querySelector('script[data-ymk-sdk="true"]')) {
      this.isYMKModuleLoaded = true;
      if (typeof successCallback === "function") {
        successCallback();
      }
      YMK.openHandAR(true);
      return true;
    }

    if (!document.querySelector('script[data-ymk-sdk="true"]')) {
      (function (d, k) {
        var s = d.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = YMK_SDK_URL + "?apiKey=" + k;
        s.dataset.ymkSdk = "true";
        var x = d.getElementsByTagName("script")[0];
        x.parentNode.insertBefore(s, x);
      })(document, YMK_SDK_API_KEY);
    }

    window.ymkAsyncInit = function () {
      this.isYMKModuleLoaded = true;

      var language = "enu";
      var htmlLang = document.documentElement.getAttribute("lang");
      if (htmlLang === "fr") {
        language = "fra";
      } else if (htmlLang === "de") {
        language = "deu";
      } else if (htmlLang === "it") {
        language = "ita";
      } else if (htmlLang === "es") {
        language = "esp";
      }
      YMK.init({
        showCloseBtnOnLauncher: true,
        language: language,
        width: this.moduleContainer.offsetWidth,
        disableNailsTakePhotoMode: true,
        hideButtonsOnResultPage: true,
      });
      YMK.openHandAR(true);
      if (typeof successCallback === "function") {
        successCallback();
      }
      // this.initSwatch();
      // this.registerYMKEvents();
    }.bind(this);

    return true;
  };

  VirtualTryOnSdk.prototype.createYMKDiv = function (container) {
    this.moduleContainer = container.querySelector(".YMK-module-container");
    if (document.querySelector("#YMK-module")) {
      // console.log('YMK-module exist in section')
      if (window.YMK) {
        YMK.close();
      }
      this.moduleContainer.appendChild(document.querySelector("#YMK-module"));
    } else {
      // console.log('YMK-module does not exist in section')
      var YMKContainer = document.createElement("div");
      YMKContainer.setAttribute("id", "YMK-module");
      this.moduleContainer.appendChild(YMKContainer);
    }
  };

  // Expose the SDK
  global.VirtualTryOnSdk = VirtualTryOnSdk;
})(window);
